import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Snackbar from '@mui/material/Snackbar';
import ShareIcon from '@mui/icons-material/Share';
import {sharePlaylistLink} from '../../../../utils/share';
import {track} from '../../../../utils/telemetry';
import styles from './PlaylistShareButton.module.scss';

interface PlaylistShareButtonProps {
    playlistId: string;
    playlistName: string;
    playlistType: 'user' | 'api';
}

export const PlaylistShareButton: React.FC<PlaylistShareButtonProps> = ({playlistId, playlistName, playlistType}) => {
    const [copied, setCopied] = React.useState(false);

    const handleShare = async () => {
        track('playlist_share', {playlistType});
        const url = `${window.location.origin}/playlists/${playlistId}`;
        const result = await sharePlaylistLink({title: playlistName, url});
        if (result === 'copied') setCopied(true);
    };

    return (
        <>
            <Tooltip title="Share">
                <IconButton
                    onClick={handleShare}
                    className={styles.shareButton__icon}
                    aria-label="Share playlist"
                >
                    <ShareIcon/>
                </IconButton>
            </Tooltip>
            <Snackbar
                open={copied}
                autoHideDuration={1800}
                onClose={() => setCopied(false)}
                message="Link copied"
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            />
        </>
    );
};
